const Connect = require("react-redux").connect;
const { push: Push } = require("react-router-redux");
const BodyModelPreview = require("../components/BodyModelPreview");
const CheckoutActions = require("actions/checkout");
const CroquisActions = require("actions/croquis");
const DialogActions = require("actions/dialog");

const internals = {};

internals.connect = Connect(
    (state, ownProps) => ({
        token: state.auth.credentials.token,
        croquis: state.croquis.all[ownProps.match.params.id]
    }),
    {
        onPurchaseClick: id => {
            return dispatch => {
                dispatch(CheckoutActions.startTransaction("purchase", id));
                dispatch(DialogActions.openTransactionDialog());
            };
        },
        onDeleteClick: id => {
            return dispatch => {
                dispatch(CroquisActions.deleteCroquis(id));
                dispatch(Push("/portfolio"));
            };
        },
        onSeeWhatsIncluded: () => {
            return dispatch => {
                dispatch(DialogActions.openWhatsIncludedDialog());
            };
        },
        fetchData: CroquisActions.fetchCroquis
    }
);

module.exports = internals.connect(BodyModelPreview);



// WEBPACK FOOTER //
// ./src/routes/body-model-preview/containers/BodyModelPreview.js